<template>
  <a-modal :visible="visible.batchModifyRaw" :bodyStyle="{ padding: '10px' }" :destroyOnClose="true" :forceRender="true"
    @ok="ok" @cancel="toggleVisible('batchModifyRaw')" width="1000px">
    <span class="title" slot="title">修改原料限制条件<b>在选中的配方中对于相同原料的限制条件进行统一编辑</b></span>
    <div class="raw-model-info-row">已选中配方：
      <span>{{ formulaSelectedRows.map(item => `【${item.formulaName}】`).join(',') }}</span>
    </div>
    <div class="raw-model-info-row">修改原料明细：</div>
    <a-spin :spinning="delLoading">
      <a-space style="padding:0 0 10px">
        <a-button @click="toggleVisible('batchAddRawList')" type="primary">添加</a-button>
      </a-space>
      <a-table :columns="columns" bordered :scroll="{ x: 970, y: 450 }" :loading="nutLoading" :data-source="list"
        :row-key="record => record.formulaCode + record.rawId" :pagination="false">
        <template slot="rawName" slot-scope="text,record">
          {{ overseasFlag == '1' ? (record.aliasName || text) : text }}
        </template>
        <template :slot="col" slot-scope="text, record" v-for="col in ['maxValue', 'minValue']">
          <cell-editor :key="col" :len="3" :item="record" :name="col" @blur="target => itemUpdate(target)" :text="text" />
        </template>
        <template slot="rawTypeName" slot-scope="text, record, index">
          <a-tooltip @visibleChange="rawTypeNameTipsVisibleChange($event, record, index)">
            <template slot="title">
              {{ record.fullTypeName }}
            </template>
            <span style="cursor: pointer" :style="{ color: record.color }">{{ text }}</span>
          </a-tooltip>
        </template>
        <template slot="option" slot-scope="record,val,index">
          <a @click="deleteItem(index)">删除</a>
        </template>
        <template slot="fixed3" slot-scope="t">
          {{ t || t === 0 ? Number(t).toFixed(3) : t }}
        </template>
      </a-table>
    </a-spin>
    <modify-raw-add-raw @ok="addRawOk" :relist="list" />
  </a-modal>
</template>
<script>
import { formulaMixins } from '../unitls';
import ModifyRawAddRaw from './ModifyRawAddRaw.vue';
import CellEditor from '../editor/CellEditor.vue';
export default {
  components: { ModifyRawAddRaw, CellEditor },
  props: ['hidden'],
  mixins: [formulaMixins],
  data() {
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      nutLoading: false,
      delLoading: false,
      filterData: {},
      list: [],
      addLoading: false,
      columns: [
        {
          dataIndex: 'rawName',
          title: '原料名称',
          scopedSlots: { customRender: 'rawName' },
        },
        {
          dataIndex: 'rawCode',
          align: 'center',
          title: '代码',
          width: 110
        },
        {
          dataIndex: 'typeName',
          title: '类型',
          width: 110,
          scopedSlots: { customRender: 'rawTypeName' },
        },
        {
          dataIndex: 'formulaName',
          title: '配方名称',
          width: 110
        },
        {
          dataIndex: 'formulaCode',
          title: '配方代码',
          width: 110
        },
        {
          dataIndex: 'taskUasgePer',
          title: '多配方用量(%)',
          scopedSlots: { customRender: 'fixed3' },
          width: 110
        },
        {
          dataIndex: 'minValue',
          title: '最小值',
          scopedSlots: { customRender: 'minValue' },
          width: 110
        },
        {
          dataIndex: 'maxValue',
          title: '最大值',
          scopedSlots: { customRender: 'maxValue' },
          width: 110
        },
        {
          title: '操作',
          align: 'center',
          width: 90,
          scopedSlots: { customRender: 'option' },
        },
      ]
    };
  },

  watch: {
    'visible.batchModifyRaw'() {
      this.restList();
    }
  },

  methods: {
    deleteItem(index) {
      let list = [...this.list];
      list.splice(index, 1);
      this.list = list;
    },

    addRawOk(list) {
      this.list = [...this.list, ...list];
    },

    itemUpdate(item) {
      const list = [...this.list];
      const targets = list.filter(i => i.formulaCode === item.formulaCode && i.rawId === item.rawId)[0];
      if (targets) {
        this.list = list;
        Object.assign(targets, item);
        this.list = list;
      }
    },

    async batchUpdate() {
      let formulaTaskFormulaRawVOList = [];
      this.list.forEach(el => {
        let newRow = JSON.parse(JSON.stringify(el));
        delete newRow.rawName;
        formulaTaskFormulaRawVOList.push(newRow);
      });
      return this.fetchPost({
        actions: this.batchUpdateFormulaRawLimitCond,
        loading: 'delLoading',
        data: {
          formulaTaskFormulaRawVOList
        }
      });
    },

    async ok() {
      if (this.list.length) {
        await this.batchUpdate();
        this.toggleVisible('batchModifyRaw');
        this.$emit('ok');
        this.$emit('refresh');
      } else {
        this.$message.warn('请添加原料后修改');
      }
    },

    getList(arg = {}) {
      return this.fetchGet({
        actions: this.selectReplaceTaskFormulaRaw,
        name: 'list',
        loading: 'nutLoading',
        data: {
          ...this.filterData,
          taskFormulaIds: this.formulaSelectedRows.map(i => i.id).join(),
          ...arg,
          size: 2000
        }
      });
    },

    restList() {
      this.list = [];
      this.filterData = {};
      this.rawType = [];
      this.cleanSelect();
    },

    typeChange(val) {
      this.rawType = val;
      const typeId = [...val].pop();
      this.filterData.typeId = typeId;
      this.getList({
        typeId
      });
    },

    rawTypeNameTipsVisibleChange(show, item) {
      item.color = show ? '#1677FF' : '';
      this.$forceUpdate();
    },
  }
};
</script>
<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;

  b {
    font-size: 12px;
    font-weight: normal;
    color: #999;
    margin-left: 10px;
  }
}

.raw-model-info-row {
  margin-bottom: 8px;

  span {
    color: #999;
  }
}
</style>
